// ======================================================================
// File Name       : UserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Col, Table, Button } from 'react-bootstrap';
import ReduxFormPaging from '../../ReduxFormPaging';
import { DORMANT_STATE } from '../../../constants';

class UserList extends Component {

  render() {
    const { targetUser, addedUserList, checkedUserOnModal, getStartEndData } = this.props;
    const { recordNum } = targetUser;

    return (
      <Col sm={12} className="padding-clear">
        <Col sm={2} className="margin-bottom-15">
          <Button variant="default" onClick={this.props.handleCheckAll}>全選択/解除</Button>
        </Col>
        <Col sm={10} className="d-flex justify-content-end">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>

        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-1" />
              <th>ユーザー名</th>
              <th>ログインID</th>
              <th>グループ名</th>
            </tr>
          </thead>
          <tbody>
            {
            targetUser && targetUser.allSecernIds &&
            targetUser.allSecernIds.map((userSecernId, index) => {
              const user = targetUser.bySecernId[userSecernId];
              const checked = checkedUserOnModal.indexOf(userSecernId) > -1;

              return (
                <tr key={index} className={user.dormantState == DORMANT_STATE.INACTIVE ? 'inactive-class' : ''}>
                  <td>
                    <Form.Check
                      type='checkbox'
                      className="text-center margin-clear"
                      value={user.userSecernId}
                      checked={!!addedUserList[userSecernId] || checked}
                      disabled={!!addedUserList[userSecernId]}
                      onChange={this.props.handleCheckbox} />
                  </td>
                  <td>{user.userName}</td>
                  <td>{user.loginId}</td>
                  <td>{user.groupName}</td>
                </tr>
              );
            })
          }
          </tbody>
        </Table>
        <Col sm={12} className="text-center">
          <Button variant="primary" className="btn-96" onClick={this.props.handleAddUser}>
            追加
          </Button>
        </Col>
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { targetUser, addedUserList } = state.csvDownload;
  return { targetUser, addedUserList };
};
export default connect(mapStateToProps)(UserList);
